import { useMemo } from 'react';
import { useGetAnalysisServersQuery } from '@/app/PageSpeed/api/analysisApi';
import { applyServerStatusToPlaceOptions } from '@/app/PageSpeed/config/analysisFormOptions';

const useAnalysisPlaceOptions = () => {
  const { data: serversData } = useGetAnalysisServersQuery();
  return useMemo(
    () => applyServerStatusToPlaceOptions(serversData?.data?.rows),
    [serversData]
  );
};

export default useAnalysisPlaceOptions;
